import React from 'react';
import s1 from '../../assets/img/softwares/1.png';
import s2 from '../../assets/img/softwares/2.png';
import s3 from '../../assets/img/softwares/3.png';
import s4 from '../../assets/img/softwares/4.png';
import s5 from '../../assets/img/softwares/5.png';
import s6 from '../../assets/img/softwares/6.png';
import s7 from '../../assets/img/softwares/7.png';
import s8 from '../../assets/img/softwares/8.png';

const SoftwaresSection = () => {
  const softwareItems = [
    { src: s1, name: "Autodesk Revit", category: "BIM SOFTWARE" },
    { src: s2, name: "AutoCAD", category: "DRAFTING" },
    { src: s3, name: "Navisworks", category: "COORDINATION" },
    { src: s4, name: "Autodesk Civil 3D", category: "CIVIL INFRA" },
    { src: s5, name: "Autodesk Recap", category: "POINT CLOUD" },
    { src: s6, name: "Solidworks", category: "3D MODELING" },
    { src: s7, name: "Sketchup", category: "3D MODELING" },
    { src: s8, name: "Adobe Creative Suite", category: "DESIGN" },
  ];

  return (
    <section className="softwares-section">
      <div className="softwares-container">
        <h2 className="softwares-title">
          <span className="text-primary">Our Tech</span> Stack
        </h2>
        <p className="softwares-subtitle">
          We use a range of tools to improve productivity and collaboration. These include architectural project management and design software, which are essential to our success.
        </p>

        <div className="softwares-grid">
          {softwareItems.map((item, index) => (
            <div key={index} className="software-tag">
              <img
                src={item.src.src || item.src}
                alt={item.name}
                style={{ height: "80px", objectFit: "contain" }}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SoftwaresSection;
